import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement, useCallback, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { EnableFor } from '../../../../__legacy__/containers/EnableForRole';
import { useLoader } from '../../../../__legacy__/helpers/useLoader';
import { useClarificationsPermissions } from '../../../../__legacy__/modules/annotation/submodules/clarifications/Clarifications.permissions';
import { IOverlayLoaderStore } from '../../../common/OverlayLoader.store';
import { ICurrentWorkspaceStore } from '../../../workspaces/currentWorkspace/CurrentWorkspace.store';
import { ClarificationsOverview } from './ClarificationsOverview';
import { IProjectOverviewBl } from './projectOverview.bl';

export const ClarificationsOverviewContainer = observer((): ReactElement => {
  const projectOverviewBl = useInjection(IProjectOverviewBl.$);
  const currentWorkspaceStore = useInjection(ICurrentWorkspaceStore.$);
  const overlayLoaderStore = useInjection(IOverlayLoaderStore.$);
  const { projectId } = useParams<{ projectId: string }>();
  const { isLoading, withLoaderAsync } = useLoader();
  const permissions = useClarificationsPermissions();

  const fetchData = useCallback(async () => {
    await withLoaderAsync(async () => await projectOverviewBl.getUnclearImagesFilter(projectId));
  }, [projectId]);

  useEffect(() => {
    void fetchData();
  }, [fetchData]);

  const { store } = projectOverviewBl;

  return (
    <EnableFor
      hasPermission={permissions.canSeeClarifications()}
      hideWhenNoAccess
    >
      <ClarificationsOverview
        workspaceId={currentWorkspaceStore.currentWorkspace.id}
        projectId={projectId}
        isLoading={isLoading && overlayLoaderStore.isSpinnerVisible('project-overview')}
        toClarify={store.unclearCount}
        oldestWaitingSince={store.unclearImageDate}
        unclearImageId={store.unclearImageId}
        unclearImagesFilterId={store.unclearImagesFilterId}
      />
    </EnableFor>
  );
});
